import hopper from './hopper';
import travelperk from './travelperk';
import budgetair from './budgetair';
import cheaptickets from './cheaptickets';
import nubank from './nubank';
import priceline from './priceline';
import allegris from './allegris';
export const themes = {
  hopper,
  travelperk,
  allegris,
  budgetair,
  cheaptickets,
  nubank,
  priceline,
};
